(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.startAt = this.parseDate(this.dataset.startAt);
      this.endAt = this.parseDate(this.dataset.endAt);
      this.daysElement = this.querySelector('[data-days]');
      this.daysSeparator = this.daysElement.nextElementSibling;
      this.hoursElement = this.querySelector('[data-hours]');
      this.minutesElement = this.querySelector('[data-minutes]');
      this.secondsElement = this.querySelector('[data-seconds]');

      this.update();
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    parseDate(value) {
      if (!value) return null;

      // Epoch seconds emitted by Liquid's date: '%s'
      const asNumber = Number(value);
      if (!Number.isNaN(asNumber) && String(value).trim() === String(asNumber)) {
        return new Date(asNumber * 1000);
      }

      // Fallback: ISO string from start_date + start_time fields
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return null;

      return parsed;
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }

    update() {
      const now = new Date();

      if (!this.startAt || !this.endAt || now < this.startAt || now >= this.endAt || this.hasActivePreviousBar()) {
        this.hidden = true;
        delete this.dataset.active;

        if (!this.startAt || !this.endAt || now >= this.endAt) {
          window.clearInterval(this.interval);
        }

        return;
      }

      const distance = this.endAt.getTime() - now.getTime();
      const totalSeconds = Math.max(0, Math.floor(distance / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.daysElement.textContent = this.pad(days);
      this.daysElement.hidden = days === 0;
      this.daysSeparator.hidden = days === 0;
      this.hoursElement.textContent = this.pad(hours);
      this.minutesElement.textContent = this.pad(minutes);
      this.secondsElement.textContent = this.pad(seconds);
      this.hidden = false;
      this.dataset.active = 'true';
    }

    hasActivePreviousBar() {
      const bars = Array.from(document.querySelectorAll('announcement-bar'));
      const currentIndex = bars.indexOf(this);

      return bars.slice(0, currentIndex).some((bar) => bar.dataset.active === 'true');
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }
  } catch(e) { console.error(e); }
})();

})();
